interface VideoCardProps {
  video: {
    id: number;
    title: string;
    cover: string;
    rating: number;
    duration: string;
    year: number;
    tags: string[];
    views: string;
    isHot?: boolean;
    isNew?: boolean;
  };
  size?: 'normal' | 'large';
}

export default function VideoCard({ video, size = 'normal' }: VideoCardProps) {
  const coverHeight = size === 'large' ? 'h-52' : 'h-40';

  return (
    <div className="group cursor-pointer">
      <div className={`relative ${coverHeight} rounded-lg overflow-hidden bg-background-200`}>
        <img
          src={video.cover}
          alt={video.title}
          title={`${video.title} - 樱桃视频免费高清在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
          <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 shadow-lg">
            <i className="ri-play-fill text-foreground-50 text-2xl ml-1"></i>
          </div>
        </div>
        {video.isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-medium bg-primary-500 text-foreground-50 rounded-md whitespace-nowrap">
            热门
          </span>
        )}
        {video.isNew && (
          <span className="absolute top-2 right-2 px-2 py-0.5 text-xs font-medium bg-accent-500 text-background-950 rounded-md whitespace-nowrap">
            上新
          </span>
        )}
        <span className="absolute bottom-2 right-2 px-1.5 py-0.5 text-xs bg-black/70 text-foreground-200 rounded whitespace-nowrap">
          {video.duration}
        </span>
        <div className="absolute bottom-2 left-2 flex items-center gap-1 text-xs text-accent-400 font-medium">
          <i className="ri-star-fill text-xs"></i>
          <span>{video.rating}</span>
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm font-medium text-foreground-100 leading-tight line-clamp-2 group-hover:text-primary-400 transition-colors">
          {video.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5 flex-wrap">
          {video.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="text-xs text-foreground-500 bg-background-200/70 px-1.5 py-0.5 rounded whitespace-nowrap">
              {tag}
            </span>
          ))}
          <span className="text-xs text-foreground-600">{video.views}次播放</span>
        </div>
      </div>
    </div>
  );
}